import { Box } from "@mui/system"
import CircularProgress from '@mui/material/CircularProgress';

function Loading() {
 
        return (
        <Box sx={{m: 1, p: 20, display: 'inline-flex', flexDirection: 'column', alignContent: 'center'}}><CircularProgress /></Box>
        );
    
} export default Loading